/**
 * Koorong: Algolia Autocomplete search request reduction
 *
 * 1. No search when the search sidebar opens (empty query)
 * 2. No search until the shopper has typed MIN_CHARS characters
 *
 * Load from theme.liquid:
 * <script src="{{ 'algolia_custom_hooks.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  var MIN_CHARS = 3; // Change to 2 if two-letter searches (e.g. "CS", "NT") matter

  // Shape of an empty Algolia result, so Autocomplete renders without erroring
  function emptyResult(q) {
    return {
      hits: [],
      nbHits: 0,
      page: 0,
      nbPages: 0,
      hitsPerPage: 0,
      processingTimeMS: 0,
      exhaustiveNbHits: true,
      query: (q && q.query) || "",
      params: "",
      index: q && q.indexName
    };
  }

  document.addEventListener("algolia.hooks.initialize", function () {
    // 1. Don't open the panel (and fire an empty search) when the input gets focus
    algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", function (options) {
      options.openOnFocus = false;
      return options;
    });

    // 2. Below MIN_CHARS, swap in a stub client so no request reaches Algolia
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteConfigurationOptions",
      function (config) {
        var queries = config.queries || [];
        var query = ((queries[0] && queries[0].query) || "").trim();

        if (query.length >= MIN_CHARS) return config;

        var stub = Object.create(config.searchClient);
        stub.search = function () {
          return Promise.resolve({ results: queries.map(emptyResult) });
        };
        config.searchClient = stub;
        return config;
      }
    );
  });
})();